import {
    ColorNeutralBlack,
    ColorSystemAttention2,
    ColorSystemNegative2,
    ColorSystemPositive2
} from 'autogen/design-tokens/tokens';
import styled from 'styled-components';

type BulletColor = 'Green' | 'Yellow' | 'Red' | 'Black';
type BulletSize = 6 | 8 | 10;

export type BulletProps = {
    color?: BulletColor;
    size?: BulletSize;
};

const getCheckmarkColor = ({ color }: Pick<BulletProps, 'color'>): string => {
    switch (color) {
        case 'Green':
            return ColorSystemPositive2;
        case 'Yellow':
            return ColorSystemAttention2;
        case 'Red':
            return ColorSystemNegative2;
        case 'Black':
        default:
            return ColorNeutralBlack;
    }
};

function dimensions({ size = 6 }: Pick<BulletProps, 'size'>) {
    return `${size}px`;
}

const BulletElement = styled.span<BulletProps>`
    display: inline-block;
    flex: none;
    background-color: ${getCheckmarkColor};
    width: ${dimensions};
    height: ${dimensions};
    border-radius: 50%;
`;

function Bullet(props: BulletProps) {
    return <BulletElement {...props} />;
}

export default Bullet;
